// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + chunkId + "-" + {"165":"76f12f93977cffa31263","672":"106a9da123d18624d0c2"}[chunkId] + ".chunk.js";
};